module.exports = __webpack_public_path__ + "img/Wp_2029.bd846bd4.png";